import React, { useMemo, useState } from 'react';
import { userTypeBreakdown } from '../../utils/userAnalytics';

function UserTypesTab({ profiles, onSelectType }) {
  const [selected, setSelected] = useState('');
  const breakdown = useMemo(() => userTypeBreakdown(profiles), [profiles]);
  const maxUsers = breakdown.reduce((m, r) => Math.max(m, r.users), 0) || 1;

  const handleSelect = (userType) => {
    const next = selected === userType ? '' : userType;
    setSelected(next);
    onSelectType?.(next);
  };

  return (
    <div className="users-tab-panel">
      <p className="users-tab-intro">
        Distinct <code>user_type</code> values from cached login rollups in the selected window.
        Click a row to preview users of that type on the Activity tab.
      </p>

      {breakdown.length === 0 ? (
        <p className="users-empty">No user types found — logins may not be cached for this range.</p>
      ) : (
        <div className="users-type-list">
          {breakdown.map(row => {
            const pct = (row.users / maxUsers) * 100;
            const isActive = selected === row.userType;
            return (
              <button
                key={row.userType}
                type="button"
                className={`users-type-row ${isActive ? 'is-active' : ''}`}
                onClick={() => handleSelect(row.userType)}
              >
                <div className="users-type-label">
                  <strong>{row.userType}</strong>
                  <span>{row.logins.toLocaleString()} logins · {row.messages.toLocaleString()} messages</span>
                </div>
                <div className="users-type-bar-track">
                  <div className="users-type-bar-fill" style={{ width: `${pct}%` }} />
                </div>
                <div className="users-type-count">{row.users.toLocaleString()}</div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default UserTypesTab;
